export default __webpack_public_path__ + "static/media/host_flag_active.f9008140.svg";